import {UserServiceClient} from '@multipass-user-service';
import {UserReasonCodes} from '@multipass-user-service-dto';

import {ReasonError} from '../reasonError';

export interface SignUpRequest {
    readonly email: string;
    readonly displayName: string;
    readonly acceptedDocumentIds: string[];
    readonly locale: string;
}

export type SignUpOutcome =
    | {readonly kind: 'codeSent'}
    | {readonly kind: 'accountExists'; readonly code: string; readonly message: string};

export interface SignupService {
    signUp(request: SignUpRequest): Promise<SignUpOutcome>;
}

export class DefaultSignupService implements SignupService {
    readonly #userServiceClient: UserServiceClient;

    constructor(userServiceClient: UserServiceClient) {
        this.#userServiceClient = userServiceClient;
    }

    public async signUp(request: SignUpRequest): Promise<SignUpOutcome> {
        const response = await this.#userServiceClient.requestSignUp({
            email: request.email,
            displayName: request.displayName,
            acceptedDocumentIds: request.acceptedDocumentIds,
            locale: request.locale,
        });
        const reason = response.errors?.[0];
        if (reason == null) {
            return {kind: 'codeSent'};
        }
        if (reason.code === UserReasonCodes.AccountAlreadyExists) {
            return {kind: 'accountExists', code: reason.code, message: reason.message};
        }
        throw new ReasonError(reason.code, reason.message);
    }
}
